import color from "../../resource/color";

/**
 * Tag colour per tier_audit_log.activity code. Keyed by code, not by the Thai label, so
 * rewording a label (tierAuditLogActivity.ts) can't silently turn a tag grey.
 * Activities not listed use grey.
 */

export function actionColorOf(activity: string, updatedBy?: string | null): string {
  switch (activity) {
    case "UPDATE_NAVISION":
      return "#1B4586";
    case "CHANGE_REBATE_DISPLAY_POLICY":
    case "CREATE_PROGRAM":
    case "UPDATE_PROGRAM":
      return "#1D874B";
    case "MANUAL_ADJUST":
    case "AUTO_PROMOTE":
    case "INITIAL_TIER":
    case "AUTO_DEMOTE":
    case "ROLLOVER":
      if(updatedBy === "SYSTEM") {
        return "#0068F4";
      }
      return "#9B51E0";
    default:
      return color.Grey;
  }
}
